import React, { PropsWithChildren } from 'react'

export const Name: React.FC<PropsWithChildren> = ({ children }) => (
  <h2 className="font-header text-body text-md font-normal mb-0">{children}</h2>
)

Name.displayName = 'Card.Name'
